<!-- Driven by the LIST, not by the appointment on screen. On the old binding the
     banner's content needed activeAppointment$, so a doctor browsing the Agenda
     on a phone with three consultations running got the orange rule and nothing
     under it - the one place they most needed the way back. -->
<!-- Not while the plan locks the app: the owner can open nothing but Subscriptions,
     so neither the open consultations nor the notifications are shown. -->
<ng-container *ngIf="!locked()">
<div *ngIf="(activeConsultations$ | async) as openList" class="z-50 shrink-0 md:hidden">
  <ng-container *ngIf="openList.length">
  <!-- Top Divider/Status Bar (Mobile Only) -->
  <div class="h-0.5 bg-[#FF6633] w-full"></div>

  <!-- Banner Content -->
  <div
    class="bg-white border-b border-gray-100 cursor-pointer hover:bg-orange-50/30 transition-colors py-2 px-6 flex items-center justify-center gap-3 group"
    (click)="goToOpenConsultation(openList)">
    <!-- Tooth/Medical Icon -->
    <div
      class="flex items-center justify-center p-1.5 bg-orange-50 rounded-lg group-hover:bg-orange-100 transition-colors">
      <svg width="18" height="18" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
        class="text-[#FF6633]">
        <path
          d="M12 6C10.926 5.414 9.417 4.5 8 4.5C5.9 4.5 4 5.747 4 9.5C4 14.399 5.056 17.91 6.671 20.037C7.244 20.793 8.641 20.558 9.238 19.801C9.636 19.296 10.057 18.362 10.5 17C10.792 16.229 11.392 15.496 12 15.5C12.602 15.5 13.21 16.237 13.5 17C13.943 18.362 14.364 19.295 14.762 19.8C15.359 20.559 16.762 20.793 17.329 20.037C18.944 17.91 20 14.4 20 9.5C20 5.76 18.092 4.5 16 4.5C14.577 4.5 13.08 5.411 12 6Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 6L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>

    <!-- Text. The count is the whole point on a phone: there is no room for the
         desktop dropdown, so this line is the only place several chairs can be
         announced. Tapping goes to the consultation page, whose chip strip is
         the picker. -->
    <span class="text-[13px] font-extrabold text-[#FF6633] uppercase tracking-wider">
      <ng-container *ngIf="openList.length > 1">{{ openList.length }} </ng-container>
      {{ 'consultation.in_progress' | translate }}
    </span>
    <i *ngIf="openList.length > 1" class="pi pi-angle-right text-[#FF6633] text-xs"></i>
  </div>
  </ng-container>
</div>
</ng-container>

<header class="bg-white border-b border-gray-200 shadow-sm z-30">
  <!-- Phones get tighter padding and gaps, the logo's mark alone and icon-only language and
       profile buttons: with the full set the row was ~480px wide and pushed the profile
       (and with it Logout) off a 360-390px screen. -->
  <div class="px-4 sm:px-6 py-3 flex items-center justify-between gap-2 sm:gap-4">
    <!-- Logo Left & Mobile Menu Toggle. Owners of several clinics get the app's mark and
         the clinic switcher beside it, as in the CRM (from 1024px; below, the bar under
         the header names the clinic). Shown while the plan locks the app too: switching is
         how an owner gets out of a locked clinic. -->
    <div class="flex min-w-0 items-center gap-2 sm:gap-3">
      <button (click)="toggleMobileMenu()" class="mobile-only-toggle shrink-0">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <ng-container *ngIf="clinicSwitch.canSwitch(); else wordmark">
        <img src="assets/icons/icon-128.webp" alt="Meta Smile" width="128" height="128"
          class="h-8 w-8 md:h-9 md:w-9 shrink-0 rounded-lg object-contain" />
        <div class="hidden lg:block min-w-0">
          <app-clinic-switcher align="start" />
        </div>
      </ng-container>
      <ng-template #wordmark>
        <img src="assets/icons/icon-128.webp" alt="Meta Smile" width="128" height="128"
          class="h-8 w-8 shrink-0 rounded-lg object-contain sm:hidden" />
        <img src="assets/images/logometasmile.png" alt="Meta Smile" class="hidden sm:block h-8 md:h-10 object-contain" />
      </ng-template>
    </div>

    <!-- NEW: Center Badge for Desktop -->
    <div *ngIf="!locked() && (isInConsultation$ | async)" class="hidden md:flex flex-1 justify-center animate-fadeIn">
      <!-- Several chairs open: the badge counts them and lists them, because
           naming only one of three is worse than naming none. With exactly one
           it behaves as it always did. -->
      <div *ngIf="(activeConsultations$ | async) as openList">
        <div *ngIf="openList.length > 1" class="relative">
          <div (click)="showConsultationMenu = !showConsultationMenu"
            class="flex items-center gap-3 px-5 py-2 bg-orange-50 border border-orange-100 rounded-2xl cursor-pointer hover:bg-orange-100 transition-all group shadow-sm">
            <div class="p-1.5 bg-white rounded-xl shadow-sm group-hover:scale-110 transition-transform">
              <i class="pi pi-users text-[#FF6633] text-xs"></i>
            </div>
            <span class="text-[11px] font-black text-[#FF6633] uppercase tracking-widest">
              {{ openList.length }} {{ 'consultation.in_progress' | translate }}
            </span>
            <i class="pi text-[10px] text-[#FF6633]"
              [ngClass]="showConsultationMenu ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </div>
          <!-- Capped height: an admin's list is the whole branch, which on a busy
               day is long enough to run off the bottom of the screen. -->
          <div *ngIf="showConsultationMenu"
            class="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 max-h-[60vh] overflow-y-auto bg-white rounded-2xl shadow-2xl border border-slate-100 py-2 z-50">
            <ng-container *ngIf="(listMeta$ | async) as meta">
              <button *ngFor="let c of openList" type="button"
                (click)="goToConsultationById(c.patient_id, c.appointment_id)"
                class="w-full px-4 py-2.5 flex items-center gap-2.5 text-left hover:bg-slate-50 transition-colors">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 shrink-0"></span>
                <span class="flex-1 min-w-0">
                  <span class="block text-xs font-bold text-slate-700 truncate">{{ c.patient_name }}</span>
                  <!-- The room, and on a branch-wide list the doctor, are what
                       tell two entries apart: concurrent consultations are one
                       per chair at the SAME time, so the time alone cannot. -->
                  <span class="block text-[10px] font-semibold text-slate-400 truncate"
                    *ngIf="(meta.spansRooms && c.office_name) || (meta.spansDoctors && c.doctor_name)">
                    <ng-container *ngIf="meta.spansRooms && c.office_name">{{ c.office_name }}</ng-container>
                    <ng-container
                      *ngIf="meta.spansRooms && c.office_name && meta.spansDoctors && c.doctor_name"> · </ng-container>
                    <ng-container *ngIf="meta.spansDoctors && c.doctor_name">{{ c.doctor_name }}</ng-container>
                  </span>
                </span>
                <span class="text-[10px] font-semibold text-slate-400 shrink-0" *ngIf="c.appointment_time_start">
                  {{ c.appointment_time_start.substring(0, 5) }}
                </span>
              </button>
            </ng-container>
          </div>
        </div>

        <!-- Exactly one open consultation: same list, just rendered as a plain
             badge instead of a dropdown. Reads openList directly rather than
             activeAppointment$ (a separately-tracked "viewed appointment" that
             Consultations clears to null on several exit paths) - that was the
             same bug the mobile banner above was already fixed for, just a
             second copy of it in the desktop badge. -->
        <div *ngIf="openList.length === 1"
          (click)="goToConsultationById(openList[0].patient_id, openList[0].appointment_id)"
          class="flex items-center gap-3 px-5 py-2 bg-orange-50 border border-orange-100 rounded-2xl cursor-pointer hover:bg-orange-100 transition-all group shadow-sm">
          <div class="p-1.5 bg-white rounded-xl shadow-sm group-hover:scale-110 transition-transform">
            <svg width="14" height="14" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
              class="text-[#FF6633]">
              <path
                d="M12 6C10.926 5.414 9.417 4.5 8 4.5C5.9 4.5 4 5.747 4 9.5C4 14.399 5.056 17.91 6.671 20.037C7.244 20.793 8.641 20.558 9.238 19.801C9.636 19.296 10.057 18.362 10.5 17C10.792 16.229 11.392 15.496 12 15.5C12.602 15.5 13.21 16.237 13.5 17C13.943 18.362 14.364 19.295 14.762 19.8C15.359 20.559 16.762 20.793 17.329 20.037C18.944 17.91 20 14.4 20 9.5C20 5.76 18.092 4.5 16 4.5C14.577 4.5 13.08 5.411 12 6Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <span class="text-[11px] font-black text-[#FF6633] uppercase tracking-widest">
            {{ 'consultation.in_progress' | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- Right Section: Notifications, Language Switcher & User Profile -->
    <div class="flex items-center gap-2 sm:gap-3 shrink-0">
      <!-- Generic notification bell -->
      <div *ngIf="!locked()" class="relative" data-testid="notification-bell">
        <button type="button" (click)="toggleNotifMenu($event)"
          [attr.aria-label]="'notifications_title' | translate" aria-haspopup="true"
          [attr.aria-expanded]="showNotifMenu"
          [pTooltip]="'notifications_title' | translate" tooltipPosition="bottom"
          class="relative flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 hover:bg-slate-50 transition-all duration-200 text-slate-600 shadow-sm">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <!-- The ping ring sits BEHIND the count rather than replacing it: the
               number is the information, the pulse is only what draws the eye to
               it. Suppressed under prefers-reduced-motion — a badge that never
               stops moving is exactly what that setting exists for. -->
          <span *ngIf="(notificationCount$ | async) as count"
            [class.hidden]="count === 0"
            class="absolute -top-1.5 -right-1.5 flex min-w-[18px] h-[18px]">
            <span
              class="absolute inline-flex h-full w-full rounded-full bg-[#FF6633] opacity-75 animate-ping motion-reduce:animate-none"></span>
            <span
              class="relative inline-flex min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF6633] text-white text-[10px] font-black items-center justify-center shadow-sm ring-2 ring-white">
              {{ count > 99 ? '99+' : count }}
            </span>
          </span>
        </button>

        <!-- Notification Dropdown -->
        <div *ngIf="showNotifMenu" role="menu"
          class="absolute right-0 mt-2 w-80 max-w-[90vw] bg-white border border-slate-200 rounded-xl shadow-lg z-50 animate-fadeIn overflow-hidden">
          <div class="px-4 py-3 border-b border-slate-100 flex items-center justify-between gap-3">
            <span class="text-sm font-black text-slate-800">{{ 'notifications_title' | translate }}</span>
            <!-- The only discovery path to notification preferences. They are
                 deliberately not in Settings: that route needs the Configuracoes
                 permission, which locked the screen away from the clinicians it
                 exists for. The bell is where you go when notifications bother
                 you, so the way to change them belongs here. -->
            <button type="button" (click)="openNotificationSettings()"
              [attr.aria-label]="'notifications_settings_title' | translate"
              [pTooltip]="'notifications_settings_title' | translate" tooltipPosition="left"
              class="text-slate-400 hover:text-primary transition-colors p-1 rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1">
              <i class="pi pi-cog !text-sm"></i>
            </button>
          </div>

          <div *ngIf="canEnablePush()" class="px-4 py-3 border-b border-slate-100 bg-slate-50 flex items-center justify-between gap-3">
            <span class="text-xs font-semibold text-slate-600">{{ 'notifications_enable_push_hint' | translate }}</span>
            <app-button [label]="(pushBusy() ? 'notifications_enabling' : 'notifications_enable_push_action') | translate"
              size="small" [disabled]="pushBusy()" (onClick)="enablePush()">
            </app-button>
          </div>
          <div *ngIf="pushBlocked()" class="px-4 py-3 border-b border-slate-100 bg-amber-50 text-xs text-amber-700">
            {{ 'notifications_push_blocked_hint' | translate }}
          </div>

          <div class="max-h-[360px] overflow-y-auto">
            <ng-container *ngIf="(notifications$ | async) as items">
              <ng-container *ngIf="(notificationReadIds$ | async) as readIds">
                <button *ngFor="let n of items" type="button" (click)="openNotification(n)"
                  class="w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-slate-50 transition-colors border-b border-slate-50 last:border-0">
                  <span class="w-8 h-8 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <i class="pi {{ notificationIcon(n.type) }} !text-sm"></i>
                  </span>
                  <span class="flex-1 min-w-0">
                    <span class="block text-sm truncate"
                      [ngClass]="readIds.has(n.id) ? 'font-medium text-slate-600' : 'font-bold text-slate-800'">{{ n.title }}</span>
                    <span *ngIf="n.body" class="block text-xs text-slate-500 truncate">{{ n.body }}</span>
                    <span class="block text-[10px] font-semibold text-slate-400 mt-0.5">{{ n.created_at | date: 'short' }}</span>
                  </span>
                  <span *ngIf="!readIds.has(n.id)"
                    class="w-2 h-2 rounded-full bg-[#FF6633] shrink-0 mt-1.5"></span>
                </button>
              </ng-container>

              <div *ngIf="items.length === 0" class="flex flex-col items-center justify-center gap-2 py-10 text-center">
                <i class="pi pi-check-circle text-2xl text-slate-200"></i>
                <span class="text-xs font-bold text-slate-400">{{ 'notifications_empty' | translate }}</span>
              </div>
            </ng-container>
          </div>

          <button type="button" (click)="viewAllNotifications()"
            class="w-full flex items-center justify-center gap-2 px-4 py-3 border-t border-slate-100 text-xs font-black uppercase tracking-wider text-slate-500 hover:text-primary hover:bg-slate-50 transition-colors">
            {{ 'notifications_view_all' | translate }}
            <i class="pi pi-arrow-right !text-[10px]"></i>
          </button>
        </div>
      </div>

      <!-- Language Switcher -->
      <div class="relative">
        <button (click)="toggleLangMenu($event)" type="button" [attr.aria-label]="'aria_select_language' | translate"
          aria-haspopup="true" [attr.aria-expanded]="showLangMenu"
          class="flex items-center gap-2 px-2.5 sm:px-3 py-1.5 rounded-xl border border-slate-200 hover:bg-slate-50 transition-all duration-200 text-sm font-medium text-slate-700 shadow-sm">
          <svg class="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
          </svg>
          <span class="hidden sm:inline font-bold">{{ activeLanguage.short }}</span>
          <svg class="hidden sm:block w-4 h-4 text-slate-400 transition-transform duration-200" [class.rotate-180]="showLangMenu"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Language Dropdown -->
        <div *ngIf="showLangMenu" role="menu"
          class="absolute right-0 mt-2 w-56 bg-white border border-slate-200 rounded-xl shadow-lg py-1 z-50 animate-fadeIn">
          <button *ngFor="let lang of languages" (click)="selectLanguage(lang.code)" type="button" role="menuitem"
            class="w-full flex items-center gap-3 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
            [class.bg-slate-50]="lang.code === currentLang">
            <span
              class="inline-flex items-center justify-center w-8 h-6 rounded-md border border-slate-200 bg-slate-50 text-[11px] font-bold text-slate-600 shrink-0">{{
              lang.short }}</span>
            <span class="flex-1 text-left font-medium">{{ lang.name }}</span>
            <svg *ngIf="lang.code === currentLang" class="w-4 h-4 text-[#FF6633] shrink-0" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
            </svg>
          </button>
        </div>
      </div>

      <!-- User Profile -->
      <div *ngIf="userInfo$ | async as userInfo" class="relative">
        <button (click)="toggleUserMenu($event)"
          class="flex items-center gap-3 p-1 sm:px-3 sm:py-1.5 rounded-full border border-slate-100 hover:bg-slate-50 transition-all duration-200">
          <div class="text-right hidden sm:block">
            <p class="text-xs font-bold text-slate-800 leading-none">
              {{ userInfo?.name || userInfo?.full_name || userInfo?.user_name || userInfo?.userName ||
              ('header_default_user' | translate) }}
            </p>
            <p class="text-[10px] text-slate-500 mt-1 leading-none">
              {{ userInfo?.email || userInfo?.company_name || ('header_no_email' | translate) }}
            </p>
          </div>

          <!-- User Avatar with Image support -->
          <div
            class="w-8 h-8 rounded-full overflow-hidden border border-slate-200 bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm">
            <img *ngIf="userInfo?.photo || userInfo?.photo_url || userInfo?.avatar_url"
              [src]="userInfo.photo || userInfo.photo_url || userInfo.avatar_url" [alt]="userInfo?.full_name"
              class="w-full h-full object-cover"
              onerror="this.src='assets/images/user-profile.png'; this.onerror=null;" />
            <span *ngIf="!userInfo?.photo && !userInfo?.photo_url && !userInfo?.avatar_url">
              {{ getUserInitials(userInfo?.full_name || userInfo?.user_name || userInfo?.userName || userInfo?.email ||
              'U') }}
            </span>
          </div>

          <svg class="hidden sm:block w-4 h-4 text-slate-400 transition-transform duration-200" [class.rotate-180]="showUserMenu"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Custom Profile Popup -->
        <app-header-profile-popup [(isOpen)]="showUserMenu" (profile)="openUserProfile()" (logout)="logout()">
        </app-header-profile-popup>
      </div>
    </div>
  </div>
</header>

<!-- Phones and tablets: the clinic in view under the header, one tap from switching (owners
     of several clinics only). Not while a consultation is open: switching waits for it to end, and its
     banner above the header has the top of the screen, so the phone does not stack three
     bands. While the plan locks the app that banner is hidden and switching is the way out,
     so the bar shows. -->
<ng-container *ngIf="(activeConsultations$ | async) as openList">
  <div *ngIf="clinicSwitch.canSwitch() && (locked() || !openList.length)"
    class="lg:hidden border-b border-slate-200 bg-white shadow-sm" data-testid="mobile-clinic-bar">
    <app-clinic-switcher variant="bar" />
  </div>
</ng-container>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 p-4">
      <app-button [label]="'NO' | translate" variant="ghost" (onClick)="cd.onReject()">
      </app-button>
      <app-button [label]="'YES' | translate" variant="primary" (onClick)="cd.onAccept()">
      </app-button>
    </div>
  </ng-template>
</p-confirmDialog>